const prefix = 'ACCOUNT';
export const GET_SUBSCRIPTION = Symbol(`${prefix}/GET_SUBSCRIPTION`);